export interface PasswordStrength {
  score: number; // 0-4
  label: 'Mycket svag' | 'Svag' | 'Medel' | 'Stark' | 'Mycket stark';
  color: string;
  checks: {
    minLength: boolean;
    hasUpperCase: boolean;
    hasLowerCase: boolean;
    hasNumber: boolean;
    hasSpecialChar: boolean;
  };
}

export const validatePasswordStrength = (password: string): PasswordStrength => {
  const checks = {
    minLength: password.length >= 8,
    hasUpperCase: /[A-Z]/.test(password),
    hasLowerCase: /[a-z]/.test(password),
    hasNumber: /[0-9]/.test(password),
    hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };

  const score = Object.values(checks).filter(Boolean).length;

  let label: PasswordStrength['label'];
  let color: string;

  if (score <= 1) {
    label = 'Mycket svag';
    color = 'bg-destructive';
  } else if (score === 2) {
    label = 'Svag';
    color = 'bg-orange-500';
  } else if (score === 3) {
    label = 'Medel';
    color = 'bg-yellow-500';
  } else if (score === 4) {
    label = 'Stark';
    color = 'bg-green-500';
  } else {
    label = 'Mycket stark';
    color = 'bg-green-600';
  }

  return { score, label, color, checks };
};
